import { Action } from "@ngrx/store";

export const LOAD_CLIENT = "[ SHARED ] - Load client configuration";
export const LOAD_CLIENT_SUBMIT = "[ SHARED ] - Load client configuration store";
export const LOAD_CLIENT_FAILED = "[ SHARED ] - Load client configuration store clear";
export const LOAD_IP_SUBMIT = "[ SHARED ] - Load ip config user";

export class LoadClient implements Action {
    public readonly type = LOAD_CLIENT;
    public constructor(public payload = null) { }
}

// tslint:disable-next-line:max-classes-per-file
export class LoadClientSubmit implements Action {
    public readonly type = LOAD_CLIENT_SUBMIT;
    public constructor(public payload) { }
}

// tslint:disable-next-line:max-classes-per-file
export class LoadIpSubmit implements Action {
    public readonly type = LOAD_IP_SUBMIT;
    public constructor(public payload) { }
}

// tslint:disable-next-line:max-classes-per-file
export class LoadClientFailed implements Action {
    public readonly type = LOAD_CLIENT_FAILED;
    public constructor() { }
}

export type All = LoadClient |
    LoadClientSubmit |
    LoadClientFailed |
    LoadIpSubmit;



// WEBPACK FOOTER //
// ./src/shared/actions/shared.actions.ts